import React from 'react'
import { InvoiceListItem } from '../../../../../lib/types/Invoice'
import { usePayInvoice } from '../../../../../services/api/invoices'
import { View } from './View'
import { notification } from 'antd'

type Props = {
  invoice: InvoiceListItem
  invoicePaid: boolean
  onInvoiceUpdate: (updatedInvoice: InvoiceListItem) => void
}

export const Container: React.FunctionComponent<Props> = ({
  invoice,
  invoicePaid,
  onInvoiceUpdate,
}) => {
  const [payInvoice, { isLoading }] = usePayInvoice(invoice.id)

  const onSubmit = () => {
    payInvoice()
      .then(({ data: updatedInvoice }) => {
        onInvoiceUpdate(updatedInvoice)
        notification.success({
          message: 'Счет успешно оплачен',
          duration: 3,
        })
      })
      .catch(() => {
        notification.error({
          message: 'Возникли ошибки при редактировании счета',
          duration: 3,
        })
      })
  }

  return (
    <View onSubmit={onSubmit} isLoading={isLoading} invoicePaid={invoicePaid} />
  )
}
